import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../../models/enums';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { VisitTypesService } from '../visit-types.service';

@Component({
  selector: 'crm-add-visit-types',
  templateUrl: './add-visit-types.component.html',
  styleUrls: ['./add-visit-types.component.css']
})
export class AddVisitTypesComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  visitType: any = {} as any


  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() visitTypeId: number;
  constructor(private readonly visitTypesService: VisitTypesService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    if (this.visitTypeId != undefined)
      this.getVisitType(this.visitTypeId);
  }

  getVisitType(visitTypeId) {
    this.displayMode = DisplayModes.Loading;
    this.visitTypesService.getById(visitTypeId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.visitType = responce as any;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get visitType');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.visitTypesService.save(this.visitType).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

}
